import React from 'react';
import { observer, inject } from 'mobx-react';


function lightbox(WrappedComponent) {
  class LightBoxEnabledComponent extends React.Component {
    constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
    }

    onClick(event) {
      const target = event.target;
      const parent = target.parentNode;
      if (target.tagName === "IMG") {
        event.preventDefault();
        let imgSrc = parent.tagName === "A" ? parent.href : target.src;
        this.props.state.setLightBox(imgSrc);
      }
    }

    render() {
      return (<span onClick={this.onClick} ><WrappedComponent {...this.props}/></span>);
    }
  }
  return inject("state")(observer(LightBoxEnabledComponent));
}

export default lightbox;


// WEBPACK FOOTER //
// ./src/components/LightBoxEnable.jsx